import { PayloadAction } from '@reduxjs/toolkit';
import { initialState } from '.';

export const reducers = {
  getSpeedControlBlockData(state) {
    state.isLoading = true;
  },
  getSpeedControlBlockDataSuccess(state, action: PayloadAction<any>) {
    state.isLoading = false;
    state.error = null;
    state.data = action.payload;
  },
  getSpeedControlBlockDataFail(state, action: PayloadAction<unknown>) {
    state.isLoading = false;
    state.data = initialState.data;
    state.error = action.payload;
  },
  setSpeedControlBlockData(state) {
    state.isLoading = false;
    state.data = initialState.data;
    state.error = null;
  },
};
